export enum EPostStatus {
  DRAFT = "DRAFT",
  ARCHIVED = "ARCHIVED",
  PUBLISH = "PUBLISH",
  PRIVATE = "PRIVATE",
}

export enum EPostType {
  REVIEW = "REVIEW",
  EVENT = "EVENT",
  COMMENT = "COMMENT",
}

export type TPost = {
  id: string;
  title: string;
  type: EPostType;

  content: any;

  timelineId: string | null;

  authorId: string;
  status: EPostStatus;
  interests: string[];
  medias: string[];

  isEdited: boolean;
  editedAt: string | null;

  parents: string[];
  eventDate: string | null;
  integrationId: string | null;
  integrationStore?: any;
  externalId: string | null;
  metadata: any;

  createdAt: string;
  updatedAt: string;
};

export type TPostAd = {
  id: string;
  title: string;
  description?: string;
  type: string;
  image?: string;
  ctaTitle: string;
  ctaLink: string;
  sales?: {
    startDateTime?: string;
    endDateTime?: string;
  };
  sponsor: {
    name: string;
    logo: string;
    website: string;
  };
};
